import _extends from "@babel/runtime/helpers/extends";
import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
var _excluded = ["items", "getItemAttributes", "getItemDescription", "getItemDisabled", "getItemIcon", "getItemKey", "getItemLabel", "getItemOnClick", "getItemRef", "getItemTagName", "isOpen", "onClose", "onItemClick", "className"];
import React, { forwardRef, useCallback, useRef, useState } from 'react';
import { cnBem, combineRefs } from '@carnica/utils';
import { Transition } from 'react-transition-group';
import { Popover } from "../../modules/Popover";
import { List } from "../../modules/List";
import { composePreparedProps, getAnimationDirection } from "./utils";
import styles from "./styles.pcss";
import { MenuItem } from "./MenuItem";
var cnMenu = cnBem('menu', styles);
var MenuRender = function MenuRender(props, ref) {
  var _composePreparedProps = composePreparedProps(props),
    items = _composePreparedProps.items,
    getItemAttributes = _composePreparedProps.getItemAttributes,
    getItemDescription = _composePreparedProps.getItemDescription,
    getItemDisabled = _composePreparedProps.getItemDisabled,
    getItemIcon = _composePreparedProps.getItemIcon,
    getItemKey = _composePreparedProps.getItemKey,
    getItemLabel = _composePreparedProps.getItemLabel,
    getItemOnClick = _composePreparedProps.getItemOnClick,
    getItemRef = _composePreparedProps.getItemRef,
    getItemTagName = _composePreparedProps.getItemTagName,
    isOpen = _composePreparedProps.isOpen,
    onClose = _composePreparedProps.onClose,
    onItemClick = _composePreparedProps.onItemClick,
    className = _composePreparedProps.className,
    otherProps = _objectWithoutProperties(_composePreparedProps, _excluded);
  var listRef = useRef(null);
  var _useState = useState(),
    _useState2 = _slicedToArray(_useState, 2),
    hoveredKey = _useState2[0],
    setHoveredKey = _useState2[1];
  var getClassName = useCallback(function (animate) {
    return function (direction) {
      return cnMenu({
        animate: animate,
        direction: getAnimationDirection(direction)
      }, [className]);
    };
  }, [className]);
  var getState = function getState(key) {
    if (typeof hoveredKey === 'undefined') {
      return 'default';
    }
    return key === hoveredKey ? 'hover' : 'faded';
  };
  var renderItem = function renderItem(item) {
    var handleClick = function handleClick(e) {
      var _getItemOnClick;
      (_getItemOnClick = getItemOnClick(item)) === null || _getItemOnClick === void 0 ? void 0 : _getItemOnClick(e);
      onItemClick === null || onItemClick === void 0 ? void 0 : onItemClick(item, e);
    };
    var attributes = getItemAttributes(item) || {};
    var itemKey = getItemKey(item);
    var onMouseEnter = function onMouseEnter(e) {
      var _attributes$onMouseEn;
      (_attributes$onMouseEn = attributes.onMouseEnter) === null || _attributes$onMouseEn === void 0 ? void 0 : _attributes$onMouseEn.call(attributes, e);
      setHoveredKey(itemKey);
    };
    var state = getState(itemKey);
    return /*#__PURE__*/React.createElement(MenuItem, _extends({}, attributes, {
      description: getItemDescription(item),
      disabled: getItemDisabled(item),
      icon: getItemIcon(item),
      label: getItemLabel(item),
      onClick: handleClick,
      onMouseEnter: onMouseEnter,
      ref: getItemRef(item),
      state: state,
      tagName: getItemTagName(item),
      "data-t-id": "components-Menu"
    }));
  };
  return /*#__PURE__*/React.createElement(Transition, {
    in: isOpen,
    nodeRef: listRef,
    timeout: 300,
    unmountOnExit: true
  }, function (animate) {
    return /*#__PURE__*/React.createElement(Popover, _extends({
      className: getClassName(animate),
      direction: "upStartLeft",
      offsetVertical: 18,
      onClickOutside: onClose,
      possibleDirections: ['upStartLeft', 'downStartLeft'],
      ref: combineRefs([ref, listRef]),
      reposition: true
    }, otherProps !== null && otherProps !== void 0 ? otherProps : {}), /*#__PURE__*/React.createElement(List, {
      className: cnMenu('list'),
      getItemKey: getItemKey,
      items: items,
      onMouseLeave: function onMouseLeave() {
        return setHoveredKey(undefined);
      },
      renderItem: renderItem,
      "data-t-id": "components-Menu"
    }));
  });
};
export var Menu = /*#__PURE__*/forwardRef(MenuRender);